// eslint-disable-next-line

// import logger from "redux-logger";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import jobDetailSlice from "../modules/jobDetailSlice";

const reducer = combineReducers({
  jobDetailSlice,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  // devTools: true,
});

export default store;
